import React from 'react';
import { useEvent } from '../../../../../../data/hooks/eventHooks';
import ActionButton from '../../../../../elements/ActionButton';
import slugifyCategory from '../../../common/slugifyCategory';
import { useTodayCategories } from './useTodayCategories';

function TodayCategories(props) {
    const { eventId, dateFilter } = props,
        event = useEvent(eventId),
        categories = useTodayCategories(eventId, dateFilter);

    if (!categories.length) return null;

    return categories.map((category) => {
        return (
            <div className="byCategory" key={category.category}>
                <ActionButton className="text-upper" href={['.', 'cat', slugifyCategory(category.category)].join('/')} next={!!category.items.length} primaryText>
                    {category.category}
                </ActionButton>
            </div>
        );
    });
}

export default TodayCategories;
